"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var params_builder_1 = require("./params_builder");
var react_router_1 = require("react-router");
var lodash_1 = require("lodash");
var bind_1 = require("../../bind");
var tracker_1 = require("@reverbdotcom/commons/dist/tracker");
var SaleSearchBar = /** @class */ (function (_super) {
    tslib_1.__extends(SaleSearchBar, _super);
    function SaleSearchBar(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { query: '' };
        return _this;
    }
    SaleSearchBar.prototype.submitQuery = function () {
        var newParams = params_builder_1.default.set(this.props.location.query, { query: this.state.query });
        this.props.router.push({
            pathname: this.props.location.pathname,
            query: newParams,
        });
    };
    SaleSearchBar.prototype.handleSubmit = function (evt) {
        evt.preventDefault();
        tracker_1.trackInteraction({
            componentName: 'SaleSearchBar',
            entityId: this.props.location.pathname,
            context: { query: this.state.query },
        });
        this.submitQuery();
    };
    SaleSearchBar.prototype.handleChange = function (evt) {
        evt.preventDefault();
        this.setState({ query: evt.target.value });
    };
    SaleSearchBar.prototype.render = function () {
        return (React.createElement("form", { className: "sale-information__search", onSubmit: this.handleSubmit },
            React.createElement("div", { className: "input-group" },
                React.createElement("input", { id: "collection_header_search", type: "text", placeholder: this.props.placeholder, className: "input-group__input", defaultValue: lodash_1.get(this.props.location, 'query.query') || '', onChange: this.handleChange }),
                React.createElement("button", { type: "submit", className: "input-group__button size-80" },
                    React.createElement("span", { className: "fa fa-chevron-right" })))));
    };
    tslib_1.__decorate([
        bind_1.default
    ], SaleSearchBar.prototype, "handleSubmit", null);
    tslib_1.__decorate([
        bind_1.default
    ], SaleSearchBar.prototype, "handleChange", null);
    return SaleSearchBar;
}(React.Component));
exports.default = react_router_1.withRouter(SaleSearchBar);
//# sourceMappingURL=sale_search_bar.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/sale_search_bar.js
// module id = 76x1
// module chunks = 20 21